// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__2Wzst","content":"GlobalSearch_content__qSa2H"};